import Billing from 'components/global/Billing';

const EdoBilling = () => <Billing />;

export default EdoBilling;
